import HttpCliente from '../HttpCliente';

/**
 * GET method - Obtiene la lista de Comediantes
 * @param {Function} setComediantes función para establecer la lista de Comediantes
 * @param {Function} setError función para establecer el estado de error
 * @return {Promise} Promesa de obtención
 */
export const getComediantes = (setComediantes, setError) => {
    return new Promise((resolve, reject) => {
        HttpCliente.get("/Comediantes", {
            headers: {
                'accept': '*/*'
            }
        })
        .then(response => {
            if (response.status === 200) {
                setComediantes(response.data); // Establece la lista de Comediantes en el estado
                resolve(response.data); // Resuelve la promesa con la respuesta del servidor
            } else {
                // Manejar otros códigos de estado
                setError(response.data.message); // Establecer el estado de Error con el mensaje
                reject(response.data.message); // Rechazar la promesa con el mensaje de error
            }
        })
        .catch(error => {
            if (error.response && error.response.data) {
                setError(error.response.data.message); // Establecer el estado de Error con el mensaje de error
                reject(error.response.data.message); // Rechazar la promesa con el mensaje de error
            } else {
                setError("Error de conexión"); // Establecer el estado de Error con un mensaje genérico
                reject("Error de conexión"); // Rechazar la promesa con un mensaje genérico
            }
        });
    });
};

/**
 * GET method - Obtiene la lista paginada de Comediantes
 * @param {Function} setComediantes función para establecer la lista de Comediantes
 * @param {Function} setError función para establecer el estado de error
 * @param {Number} page número de página
 * @param {Number} pageSize tamaño de página
 * @param {String} searchTerm término de búsqueda opcional
 * @return {Promise} Promesa de obtención
 */
export const getComediantesPaginados = (setComediantes, setError, page = 1, pageSize = 5, searchTerm = "", token) => {
    return new Promise((resolve, reject) => {
        let url = `/Comediantes/paged?pageNumber=${page}&pageSize=${pageSize}`;
        if (searchTerm) {
            url += `&searchTerm=${encodeURIComponent(searchTerm)}`;
        }

        HttpCliente.get(url, {
            headers: {
                "Authorization": `Bearer ${token}`,
                'accept': '*/*'
            }
        })
        .then(response => {
            if (response.status === 200) {
                setComediantes(response.data); // Establece la lista paginada de Comediantes
                resolve(response.data);
            } else {
                setError(response.data.message);
                reject(response.data.message);
            }
        })
        .catch(error => {
            if (error.response && error.response.data) {
                setError(error.response.data.message);
                reject(error.response.data.message);
            } else {
                setError("Error de conexión");
                reject("Error de conexión");
            }
        });
    });
};

/**
 * GET method - Obtiene un Comediante por ID
 * @param {String} id ID del comediante
 * @param {Function} setComediante función para establecer el comediante
 * @param {Function} setError función para establecer el estado de error
 * @return {Promise} Promesa de obtención
 */
export const getComedianteById = (id, setComediante, setError) => {
    return new Promise((resolve, reject) => {
        HttpCliente.get(`/Comediantes/${id}`)
        .then(response => {
            if (response.status === 200) {
                setComediante(response.data.data);
                resolve(response.data);
            } else {
                setError(response.data.message);
                reject(response.data.message);
            }
        })
        .catch(error => {
            if (error.response && error.response.data) {
                setError(error.response.data.message);
                reject(error.response.data.message);
            } else {
                setError("Error de conexión");
                reject("Error de conexión");
            }
        });
    });
};

/**
 * POST method - Crea un nuevo Comediante
 * @param {Object} comedianteData datos del nuevo comediante
 * @param {Function} setError función para establecer el estado de error
 * @param {String} token token de autenticación
 * @return {Promise} Promesa de creación
 */
export const createComediante = (comedianteData, setError, token) => {
  return new Promise((resolve, reject) => {
    HttpCliente.post("/Comediantes", comedianteData, {
      headers: {
        "Authorization": `Bearer ${token}`,
        "accept": "*/*",
        // ⚠️ NO pongas 'Content-Type' manualmente
        // axios detecta automáticamente multipart/form-data cuando es FormData
      },
    })
      .then(response => {
        if (response.status === 201 || response.status === 200) {
          resolve(response.data);
        } else {
          setError(response.data.message);
          reject(response.data.message);
        }
      })
      .catch(error => {
        if (error.response && error.response.data) {
          setError(error.response.data.message);
          reject(error.response.data.message);
        } else {
          setError("Error de conexión");
          reject("Error de conexión");
        }
      });
  });
};


export const updateComediante = (id, comedianteData, setError, token) => {
  return new Promise((resolve, reject) => {
    HttpCliente.put(`/Comediantes/${id}`, comedianteData, {
      headers: {
        "Authorization": `Bearer ${token}`,
        "accept": "*/*",
        // igual que arriba, axios maneja el Content-Type
      },
    })
      .then(response => {
        if (response.status === 200) {
          resolve(response.data);
        } else {
          setError(response.data.message);
          reject(response.data.message);
        }
      })
      .catch(error => {
        if (error.response && error.response.data) {
          setError(error.response.data.message);
          reject(error.response.data.message);
        } else {
          setError("Error de conexión");
          reject("Error de conexión");
        }
      });
  });
};

/**
 * DELETE method - Elimina un Comediante
 * @param {String} id ID del comediante a eliminar
 * @param {Function} setError función para establecer el estado de error
 * @param {String} token token de autenticación
 * @return {Promise} Promesa de eliminación
 */
export const deleteComediante = (id, setError, token) => {
    return new Promise((resolve, reject) => {
        HttpCliente.delete(`/Comediantes/${id}`, {
            headers: {
                "Authorization": `Bearer ${token}`,
                'accept': '*/*'
            }
        })
        .then(response => {
            if (response.status === 200 || response.status === 204) {
                resolve(response.data);
            } else {
                setError(response.data.message);
                reject(response.data.message);
            }
        })
        .catch(error => {
            if (error.response && error.response.data) {
                setError(error.response.data.message);
                reject(error.response.data.message);
            } else {
                setError("Error de conexión");
                reject("Error de conexión");
            }
        });
    });
};

/**
 * PATCH method - Cambia el estado de habilitado de un Comediante
 * @param {String} id ID del comediante
 * @param {Boolean} status nuevo estado (true = habilitar, false = deshabilitar)
 * @param {Function} setError función para establecer el estado de error
 * @param {String} token token de autenticación
 * @return {Promise} Promesa de actualización
 */
export const toggleComediante = (id, status, setError, token) => {
  return new Promise((resolve, reject) => {
    HttpCliente.patch(`/Comediantes/${id}/toggle?status=${status}`, {}, {
      headers: {
        "Authorization": `Bearer ${token}`,
        "accept": "*/*"
      }
    })
    .then(response => {
      if (response.status === 200) {
        resolve(response.data);
      } else {
        setError(response.data.message);
        reject(response.data.message);
      }
    })
    .catch(error => {
      if (error.response && error.response.data) {
        setError(error.response.data.message);
        reject(error.response.data.message);
      } else {
        setError("Error de conexión");
        reject("Error de conexión");
      }
    });
  });
};
